import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    supportedLngs: ["fr", "en"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    fallbackLng: ["fr", "en"],
    lng: window.localStorage.getItem("userLanguage") || navigator.language,
    ns: ["translations"],
    defaultNS: "translations",
    react: {
      useSuspense: false
    },
    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
